import { render, staticRenderFns } from "./AuthResetLink.vue?vue&type=template&id=55b306ef&scoped=true&lang=pug&"
import script from "./AuthResetLink.vue?vue&type=script&lang=js&"
export * from "./AuthResetLink.vue?vue&type=script&lang=js&"
import style0 from "./AuthResetLink.vue?vue&type=style&index=0&id=55b306ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b306ef",
  null
  
)

export default component.exports